import classNames from 'classnames/bind';

import styles from './S03.module.scss';

const cx = classNames.bind(styles);

const S03 = () => {
  return (
    <div className={cx('container')}>
      <h2 className={cx('headline')}>풀무원 퓨어는?</h2>
      <img src={require('../../../assets/images/products/pure/s03/box.png')} alt="풀무원 퓨어는?" />
    </div>
  );
};

export default S03;
